import { Typography, Stack } from "@mui/material";
import { InvestigationItemContainer } from "../components/InvestigationItemContainer";
import { useTranslation } from "react-i18next";

export const SingleCause = ({ cause }) => {

  const [t] = useTranslation("investigation");

  const { reason, details } = cause;

  return (
    <InvestigationItemContainer color="#B694FF"sx={{ padding: 2 }} >

      <Stack direction="row" alignItems="center">

        <Typography fontSize={14} fontWeight={600} >
          {t("evaluation.cause")}:
        </Typography>
        &nbsp;
        <Typography fontSize={14} fontWeight={700} color="#B694FF" >
          {reason}
        </Typography>
      </Stack>

      {
        !!details && 
        <>
          <hr />
          <Typography fontSize={16} >
            {details}
          </Typography>
        </>
      }

    </InvestigationItemContainer>
  )
};